import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {StudyOverviewViewQuery} from 'studies/workspace/overview/__generated/StudyOverviewViewQuery';

import StudyExecutionToolbar from '../utils/ui/StudyExecutionToolbar';

type StudyNode = ExtractByTypename<StudyOverviewViewQuery['study'], 'StudyNode'>;

export default function CustomStudyExecutionOverview({study}: {study: StudyNode}): JSX.Element {
  return <StudyExecutionToolbar study={study} />;
}
